import React from "react";
import { Navigate, Route } from "react-router-dom";

import ComprasLayout from "../pages/Templates/Template-Administrativo/Compras/ComprasLayout";

export const comprasRoutes = (
  <>
    <Route
      path="/suprimentos/compras"
      element={<Navigate to="/suprimentos/compras/visao-geral" replace />}
    />

    <Route
      path="/suprimentos/compras/visao-geral"
      element={<ComprasLayout section="visao-geral" />}
    />

    <Route
      path="/suprimentos/compras/pendencias"
      element={<ComprasLayout section="pendencias" />}
    />

    <Route
      path="/suprimentos/compras/aguardando-pagamento"
      element={<ComprasLayout section="aguardando-pagamento" />}
    />

    <Route
      path="/suprimentos/compras/pagas"
      element={<ComprasLayout section="pagas" />}
    />

    <Route
      path="/suprimentos/compras/canceladas"
      element={<ComprasLayout section="canceladas" />}
    />
  </>
);
